import {
    FETCH_BODY_BATTERY_TODAY,
    FETCH_BODY_BATTERY_TODAY_SUCCESS,
    FETCH_BODY_BATTERY_TODAY_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    bodyBatteryToday: {},
    bodyBatteryTodayFetching: false,
    bodyBatteryTodayFetchFail: false
};

const fetchBodyBatteryTodayRequested = (state, action) => {
    return {
        bodyBatteryToday: {
            ...state.bodyBatteryToday
        },
        bodyBatteryTodayFetching: true,
        bodyBatteryTodayFetchFail: false
    };
};

const fetchBodyBatteryTodaySuccess = (state, action) => {
    return {
        bodyBatteryToday: {
            ...state.bodyBatteryToday,
            [action.displayName]: {
                ...state.bodyBatteryToday[action.displayName],
                [action.calendarDate]: action.bodyBatteryToday
            }
        },
        bodyBatteryTodayFetching: false,
        bodyBatteryTodayFetchFail: false
    };
};

const fetchBodyBatteryTodayFail = (state, action) => {
    return {
        bodyBatteryToday: {
            ...state.bodyBatteryToday,
            [action.displayName]: {
                ...state.bodyBatteryToday[action.displayName],
                [action.calendarDate]: {}
            }
        },
        bodyBatteryTodayFetching: false,
        bodyBatteryTodayFetchFail: true
    };
};

const handlers = {
    [FETCH_BODY_BATTERY_TODAY]: fetchBodyBatteryTodayRequested,
    [FETCH_BODY_BATTERY_TODAY_SUCCESS]: fetchBodyBatteryTodaySuccess,
    [FETCH_BODY_BATTERY_TODAY_FAIL]: fetchBodyBatteryTodayFail
};

// ======= Actions =======
export function fetchBodyBatteryToday(displayName, calendarDate, evictCache) {
    return {
        type: FETCH_BODY_BATTERY_TODAY,
        displayName: displayName,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getBodyBatteryToday = (state, displayName, calendarDate) => {
    return state.bodyBatteryToday.bodyBatteryToday[displayName]
        ? state.bodyBatteryToday.bodyBatteryToday[displayName][calendarDate]
        : null;
};

export const isBodyBatteryTodayFetching = (state) => {
    return state.bodyBatteryToday.bodyBatteryFetching;
};

export const didBodyBatteryTodayFetchFail = (state) => {
    return state.bodyBatteryToday.bodyBatteryFetchFail;
};

// ======= Default =======
export default function bodyBatteryToday(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
